import getQueryKey from './getQueryKey.mjs';

function getDefaultConfig({
  remote,
  extraParams
}) {
  const [remoteFn, defaultConfig, extraConfigGenerator] = remote;
  const requestConfig = {
    ...defaultConfig,
    ...extraConfigGenerator?.(extraParams)
  };
  const key = getQueryKey(requestConfig);
  const queryFn = async ({ signal }) => {
    const options = { signal };
    const params = {
      ...requestConfig.params,
      ...extraParams
    };
    const response = await remoteFn(params, options);
    return response.data;
  };
  return { key, queryFn };
}

export { getDefaultConfig as default };
//# sourceMappingURL=getDefaultConfig.mjs.map
